export default "__VITE_ASSET__BPvxh$mu__"